import http from '../http'
import config from '../../config.js'

export const generateS3SubmittingUrlMulti = (body) => {
  return http.POST(config.serverEndpoint + '/files/upload-multi', body)
}
